import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLayout } from '../../core'
// import {Header} from './Header'
import { Button } from 'antd'
import { Header } from 'antd/es/layout/layout'
import { isEmpty } from 'lodash'
import { FaBars } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { ISettingTypeState } from 'src/app/modules/siteSettings/components/settings'
import {settingAssetUrl} from 'src/app/queries/signedMediaUrl'
import { ActiveMenuContex } from '../../MasterLayout'
import { Topbar } from './Topbar'

export function HeaderWrapper() {
  const {config, classes, attributes} = useLayout()
  const {header, aside} = config
  const [logo, setLogo] = useState('')
  const activeMenu: any = useContext(ActiveMenuContex)
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'mainLogo') {
            setLogo(settingAssetUrl(item))
          }
        })
    }
  }, [settingTypeData])
  const showDrawer = () => {
    activeMenu.setOpen(true)
  }
  return (
    <>
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 9,
          boxShadow: 'rgba(122, 122, 122, 0.12) 0px 0.4rem 0.7rem',
        }}
        className='d-flex align-items-center justify-content-between'
      >
        <div>
          <Button
            type='primary'
            size='large'
            icon={<FaBars />}
            style={{marginRight: '1rem'}}
            onClick={showDrawer}
          />
          <Link to='/dashboard'>
            <img
              alt='Logo'
              className=' logo'
              height={45}
              // src='/media/logos/bank-log.png'
              src={logo || `/media/logos/bank-log.png`}
            />
          </Link>
        </div>

        <Topbar />
      </Header>
    </>
  )
}
